import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const AdvertisePage = () => (
  <Layout>
    <SEO title="Advertise" />
    <h2>Advertisments</h2>
    <div>
      <ul>
        <li>Question about the information on the site?</li>
      </ul>
    </div>
  </Layout>
)

export default AdvertisePage